<template>
  <div class="sample-page">
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <router-link to="/sample">样本管理</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>样本信息</a-breadcrumb-item>
      </a-breadcrumb>
    </div>

    <div class="page-content">
      <div class="panel-page">
        <div class="panel-title">样本信息</div>
        <div class="panel-content">
          <div class="content-item">
            <a-row>
              <a-col :xs="{ span: 10, offset: 1 }" :lg="{ span: 10, offset: 2 }">
                <div class="row-item">
                  <span class="row-lable">协作组条码:</span>
                  <span class="row-content">{{mockData.hosBarCode}}</span>
                </div>
                <div class="row-item">
                  <span class="row-lable">样本编号：</span>
                  <span class="row-content">{{mockData.sampleId}}</span>
                </div>
                <div class="row-item">
                  <span class="row-lable">检验项目:</span>
                  <span class="row-content">{{mockData.applyItemNameDict}}</span>
                </div>
                <div class="row-item">
                  <span class="row-lable">样本类型:</span>
                  <span class="row-content">{{mockData.sampleTypeNameDict}}</span>
                </div>
                <div class="row-item">
                  <span class="row-lable">操作状态:</span>
                  <span class="row-content">{{mockData.operateStatusDict}}</span>
                </div>
                <div class="row-item">
                  <span class="row-lable">存储位置:</span>
                  <span class="row-content">{{mockData.address }}</span>
                </div>
                <div class="row-item">
                  <span class="row-lable">操 作 人:</span>
                  <span class="row-content">{{mockData.optUsername }}</span>
                </div>
              </a-col>
              <a-col :xs="{ span: 10, offset: 1 }" :lg="{ span: 10, offset: 2 }">
                <div class="row-item">
                  <span class="row-lable">测序中心条码:</span>
                  <span class="row-content">{{mockData.barCode}}</span>
                </div>
                <div class="row-item">
                  <span class="row-lable">流转机构：</span>
                  <span class="row-content">{{mockData.deptName}}</span>
                </div>
                <div class="row-item">
                  <span class="row-lable">专业组:</span>
                  <span class="row-content">{{mockData.groupName}}</span>
                </div>
                <div class="row-item">
                  <span class="row-lable">样本量:</span>
                  <span class="row-content">{{toDecimal(mockData.sampleAmount)}}</span>
                </div>
                <div class="row-item">
                  <span class="row-lable">操作时间:</span>
                  <span class="row-content">{{moment(mockData.optTime).format(dateFormat) }}</span>
                </div>
                <div class="row-item">
                  <span class="row-lable">入库日期:</span>
                  <span class="row-content">{{moment(mockData.createTime).format('YYYY-MM-DD') }}</span>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
      <div class="panel-page panel-page2">
        <div class="panel-title">操作明细</div>
        <div class="panel-tip">
          <div class="content-item">
            <a-table
              class="hospital-table-detail"
              :columns="columns"
              :pagination="false"
              :dataSource="data"
              :rowKey="record => record.id"
              size="small"
            >
              <template
                slot="scopedSampleAmount"
                slot-scope="text,record"
              >{{toDecimal(record.sampleAmount)}}</template>
              <template slot="scopedCreateDate" slot-scope="text,record">
                <span v-if="record.createDate">{{moment(record.createDate).format('YYYY-MM-DD') }}</span>
                <span v-else>--</span>
              </template>
              <template
                slot="scopedOptTime"
                slot-scope="text,record"
              >{{moment(record.optTime).format(dateFormat) }}</template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

const columns = [
  {
    title: "操作状态",
    dataIndex: "operateStatusDict"
  },
  {
    title: "操作人",
    dataIndex: "nickName"
  },
  {
    title: "流转机构",
    dataIndex: "deptName"
  },
  {
    title: "检验项目",
    dataIndex: "applyItemNameDict"
  },
  {
    title: "专业组",
    dataIndex: "groupName"
  },
  {
    title: "存储位置",
    dataIndex: "address"
  },
  {
    title: "样本类型",
    dataIndex: "sampleTypeNameDict"
  },
  {
    title: "样本量",
    scopedSlots: { customRender: "scopedSampleAmount" },
    dataIndex: "sampleAmount"
  },
  {
    title: "入库日期",
    scopedSlots: { customRender: "scopedCreateDate" }
    // dataIndex: "createDate"
  },
  {
    title: "操作时间",
    scopedSlots: { customRender: "scopedOptTime" }
    // dataIndex: "updateTime"
  }
];
// let mockData = {
//     hosBarCode: "CCCGxxxyyyyyy",
//     barCode: "30D009C00001",
//     sampleId: "18-CALSIII-AML18协作组-000002-DNA-001",
//     sampleAmount: "1.00ml",
//     sampleType: "细胞",
//     address: "--罐*--层 --格",
//     operateType: "入库",
//     operateDate: "2019-02-15",
//     userName: "李四",
//     msgFrom: "aaaa"
// };
// const data = [];
// for (let i = 0; i < 10; i++) {
//     mockData.keyname = new Date().getTime();
//     data.push(mockData);
// }

export default {
  data() {
    return {
      dateFormat: "YYYY-MM-DD HH:mm:ss",
      data: [],
      resData: [],
      columns,
      queryId: "",
      mockData: {},
      page: 1,
      pageSize: 10
    };
  },
  mounted() {
    this.queryId = this.$route.query.id;
    this.getSampleInfo();
    this.findSampleInfoHistory();
  },
  methods: {
    moment,
    getSampleInfo() {
      this.$get("sampleinfo/detail/" + this.queryId + "").then(res => {
        this.mockData = res.data.data;
      });
    },
    findSampleInfoHistory() {
      this.$get("sampleinfo/findSampleInfoHistory/" + this.queryId + "").then(
        res => {
          this.data = res.data.data;
        }
      );
    },
    toDecimal(x) {
      var f = 0;
      //判断是否是字符串类型
      try {
        if (typeof x == "string") {
          if (x != null && x != "") {
            f = parseFloat(x);
          }
        } else {
          f = x;
        }
        f = f.toFixed(2);
      } catch (e) {}
      return f;
    }
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        onChange: (selectedRowKeys, selectedRows) => {

        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.name === "Disabled User", // Column configuration not to be checked
            name: record.name
          }
        })
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.sample-page {
  width: 100%;
  min-width: 1200px;
  .page-handle {
    height: 60px;
    background: #f8fbfb;
    padding: 0 40px;
    line-height: 60px;
    border-top: 1px solid rgba(240, 242, 245, 1);
    border-bottom: 1px solid rgba(240, 242, 245, 1);
    .right {
      float: right;
      height: 60px;
      .hospital-dropdown-link {
        margin-left: 25px;
      }
      .hospital-dropdown-link {
        color: #3e7ff7;
        font-size: 12px;
      }
    }
    .left {
      height: 60px;
      float: left;
      .ant-btn + .ant-btn {
        margin-left: 5px;
      }
    }
  }
  .page-content {
    padding: 40px 40px;
    background: #fff;
    .row-item {
      margin-bottom: 28px;
    }
    .panel-page2 {
      margin-top: 40px;
    }
    .panel-title {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 36px;
    }
    .panel-tip {
      margin-top: 20px;
    }
    .panel-content {
      margin-top: 13px;
      background: rgba(249, 251, 251, 1);
      border: 1px solid rgba(240, 242, 245, 1);
      padding: 36px 0 0 0;
      .row-lable {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(164, 164, 164, 1);
      }
      .row-content {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-left: 20px;
      }
    }
  }
}
</style>